module.exports = __webpack_public_path__ + "static/media/pdf-file-white.e90a6215.svg";